;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["csrf_token", "send_otp_url", "api_login_url", "login_type"],
    data: function data() {
        return {
            selected_user: {},
            changeset: {},
            timerRunning: false,
            showLoginButtons: true,
            minutes: "",
            seconds: "",
            admin: false,
            agent: false,
            otpInput: false,
            login: false
        };
    },
    methods: {
        capitalizeOTP: function capitalizeOTP(event) {
            this.selected_user.otp = event.target.value.toUpperCase();
        },

        updateTimer: function updateTimer(val) {
            this.timerRunning = val;
        },
        reset_view: function reset_view() {
            if (this.selected_user.email) this.send_otp();
        },
        admin_signin: function admin_signin() {
            if (this.selected_user.email) {
                this.admin = true;
                this.agent = false;
                this.showLoginButtons = false;
                if (this.login_type == "otp") this.send_otp();
            } else {
                this.changeset = {
                    message: "Please enter your email or phone number"
                };
            }
        },
        agent_signin: function agent_signin() {
            if (this.selected_user.email) {
                this.admin = false;
                this.agent = true;
                this.showLoginButtons = false;
            } else {
                this.changeset = {
                    message: "Please enter your email or phone number"
                };
            }
        },
        send_otp: function send_otp() {
            if (!this.selected_user.email && !this.selected_user.password || !this.selected_user.email && !this.selected_user.pin) {
                this.changeset = {
                    message: "Please enter your credentials"
                };
            } else if (!this.selected_user.email && this.selected_user.password || !this.selected_user.email && this.selected_user.pin) {
                this.changeset = {
                    message: "Please enter your email or phone number"
                };
            } else {
                this.changeset = {};
                var self = this;
                var payload = {};
                if (this.admin) {
                    payload = {
                        email: this.selected_user.email,
                        password: this.selected_user.password,
                        type: "admin",
                        login_type: this.login_type,
                        csrf_token: this.csrf_token
                    };
                } else if (this.agent) {
                    payload = {
                        email: this.selected_user.email,
                        pin: this.selected_user.pin,
                        type: "agent",
                        csrf_token: this.csrf_token
                    };
                }
                _axios2.default.post(this.send_otp_url, payload).then(function (response) {
                    if (response.data.status == "success") {
                        self.showLoginButtons = false;
                        self.timerRunning = true;
                        self.otpInput = true;
                        self.login = true;
                        self.selected_user = response.data.user;
                    } else {
                        self.timerRunning = false;
                        self.changeset = response.data.errors;
                    }
                }).catch(function (error) {
                    self.changeset = error;
                });
            }
        },
        validate_otp: function validate_otp() {
            this.changeset = {};
            var self = this;
            var payload = {};
            if (this.admin) {
                payload = {
                    email: this.selected_user.email,
                    password: this.selected_user.password,
                    type: "admin",
                    login_type: this.login_type,
                    otp: this.selected_user.otp,
                    csrf_token: this.csrf_token,
                    phone_number: this.selected_user.phone_number
                };
            }
            if (this.agent) {
                payload = {
                    email: this.selected_user.email,
                    pin: this.selected_user.pin,
                    type: "agent",
                    otp: this.selected_user.otp,
                    csrf_token: this.csrf_token,
                    phone_number: this.selected_user.phone_number
                };
            }

            _axios2.default.post(this.api_login_url, payload).then(function (response) {
                if (response.data.status == "success") {
                    location.assign(response.data.redirect_url);
                } else {
                    self.changeset = response.data.errors;
                }
            }).catch(function (error) {
                self.changeset = error;
            });
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',[(_vm.changeset.message != null)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.changeset.message))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email or Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.email),expression:"selected_user.email"}],staticClass:"form-control",class:{ 'is-invalid': 'email' in _vm.changeset },attrs:{"type":"text","name":"email","required":"","autofocus":""},domProps:{"value":(_vm.selected_user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "email", $event.target.value)}}}),_vm._v(" "),('email' in _vm.changeset)?_c('div',{staticClass:"invalid-feedback"},[_c('span',[_vm._v(_vm._s(_vm.changeset.email))])]):_vm._e()]),_vm._v(" "),(_vm.admin && _vm.login_type == 'password')?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"pin"}},[_vm._v("Enter Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.password),expression:"selected_user.password"}],staticClass:"form-control",class:{ 'is-invalid': 'password' in _vm.changeset },attrs:{"type":"password","name":"pin","required":"","autofocus":""},domProps:{"value":(_vm.selected_user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "password", $event.target.value)}}}),_vm._v(" "),('password' in _vm.changeset)?_c('div',{staticClass:"invalid-feedback"},[_c('span',[_vm._v(_vm._s(_vm.changeset.password))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.agent)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"pin"}},[_vm._v("Enter PIN")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.pin),expression:"selected_user.pin"}],staticClass:"form-control",class:{ 'is-invalid': 'pin' in _vm.changeset },attrs:{"type":"password","maxlength":"8","name":"pin","required":"","autofocus":""},domProps:{"value":(_vm.selected_user.pin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "pin", $event.target.value)}}}),_vm._v(" "),('pin' in _vm.changeset)?_c('div',{staticClass:"invalid-feedback"},[_c('span',[_vm._v(_vm._s(_vm.changeset.pin))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.otpInput),expression:"otpInput"}],staticClass:"form-group"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('label',{attrs:{"for":"otp"}},[_vm._v("Enter OTP")]),_vm._v(" "),(_vm.timerRunning)?_c('p',[_c('TimerComponent',{on:{"update:timer":_vm.updateTimer}})],1):_c('a',{attrs:{"href":"#"},on:{"click":_vm.reset_view}},[_vm._v("OTP expired. Resend OTP?")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.otp),expression:"selected_user.otp"}],staticClass:"form-control",class:{ 'is-invalid': 'otp' in _vm.changeset },attrs:{"type":"text","maxlength":"8","name":"otp","required":"","autofocus":""},domProps:{"value":(_vm.selected_user.otp)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "otp", $event.target.value)},_vm.capitalizeOTP]}}),_vm._v(" "),('otp' in _vm.changeset)?_c('div',{staticClass:"invalid-feedback"},[_c('span',[_vm._v(_vm._s(_vm.changeset.otp))])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoginButtons),expression:"showLoginButtons"}],staticClass:"row mb-3"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-block btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.admin_signin}},[_vm._v("Admin Signin")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-block btn-outline-success",attrs:{"type":"button"},on:{"click":_vm.agent_signin}},[_vm._v("Agent Signin")])])]),_vm._v(" "),(!_vm.showLoginButtons && !_vm.login)?_c('div',[_c('button',{staticClass:"btn btn-block btn-outline-success mb-3",attrs:{"type":"button"},on:{"click":_vm.send_otp}},[_vm._v("\n                    Proceed "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("→")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.login),expression:"login"}]},[_c('button',{staticClass:"btn btn-block btn-outline-success mb-3",attrs:{"type":"button"},on:{"click":_vm.validate_otp}},[_vm._v("\n                    Sign in "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("→")])])])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b14259bc", __vue__options__)
  } else {
    hotAPI.reload("data-v-b14259bc", __vue__options__)
  }
})()}